export class PerfilInvestimentoADO {
    dT_REFERENCIA : Date;
    iD_PLANO : number;
    iD_EMP : number;
    iD_PERFIL : number;
    nM_PERFIL : string;
    pC_PERFIL : number;
}